import { put, takeEvery, call } from "redux-saga/effects";
// import { appConfig } from "../../config";
import "react-toastify/dist/ReactToastify.css";
import { toast } from "react-toastify";
import * as actionTypes from "./constants";
import * as actionType from "../ApartmentContainer/constants";

import endpoints from "../endpoints";
// import api from "../api";
import fmApi from "../APIWrapper";

// function* commonFunction(value) {
//   const token = localStorage.getItem("fmsToken");
//   try {
//     const res = yield fetch(`${value.api}`, {
//       method: `${value.method}`,
//       headers: {
//         Accept: "application/json",
//         "Content-Type": "application/json",
//         Authorization: `Bearer ${token}`,
//         type: "Web",
//       },
//       body: value.body ? value.body : null,
//     });
//     if (!res.ok) {
//       throw res;
//     } else {
//       const resJSON = yield res.json();
//       yield put({
//         type: `${value.sucessAction}`,
//         payload: resJSON,
//       });
//       yield put({
//         type: `${value.initAction}`,
//       });
//       yield toast.success(value.toastMsg, {
//         autoClose: 3000,
//       });
//       return resJSON;
//     }
//   } catch (err) {
//     if (err.ok === false) {
//       yield put({ type: `${value.failAction}`, error: err });
//     } else {
//     }
//   }
// }

// function* commonPostFunction(value) {
//   const token = localStorage.getItem("fmsToken");
//   try {
//     const res = yield fetch(`${value.api}`, {
//       method: `${value.method}`,
//       headers: {
//         Accept: "application/json",
//         "Content-Type": "application/json",
//         Authorization: `Bearer ${token}`,
//         type: "Web",
//       },
//       body: value.body ? value.body : null,
//     });
//     if (!res.ok) {
//       throw res;
//     } else {
//       const resJSON = yield res.json();
//       yield put({
//         type: `${value.sucessAction}`,
//         payload: resJSON,
//       });
//       yield put({
//         type: `${value.initAction}`,
//       });
//       yield toast.success(value.toastMsg, {
//         autoClose: 3000,
//       });
//       return resJSON;
//     }
//   } catch (err) {
//     if (err.ok === false) {
//       if (err.status === 400) {
//         yield put({ type: `${value.failAction}`, error: err });
//         yield toast.error(`${endpoints.status400}`);
//       } else if (err.status === 500) {
//         yield put({ type: `${value.failAction}`, error: err });
//         yield toast.error(`${endpoints.status500}`);
//       } else {
//       }
//     }
//   }
// }

// function* commonAdjustFunction(value) {
//   const token = localStorage.getItem("fmsToken");
//   try {
//     const res = yield fetch(`${value.api}`, {
//       method: `${value.method}`,
//       headers: {
//         Accept: "application/json",
//         "Content-Type": "application/json",
//         Authorization: `Bearer ${token}`,
//         type: "Web",
//       },
//       body: value.body ? value.body : null,
//     });
//     if (!res.ok) {
//       throw res;
//     } else {
//       const resJSON = yield res.json();
//       yield put({
//         type: `${value.sucessAction}`,
//         payload: resJSON,
//       });
//       yield put({
//         type: `${value.initAction}`,
//       });
//       yield toast.success(value.toastMsg, {
//         autoClose: 3000,
//       });
//       return resJSON;
//     }
//   } catch (err) {
//     if (err.ok === false) {
//       yield put({ type: `${value.failAction}`, error: err });
//       yield put({
//         type: `${value.initActionFail}`,
//       });
//       yield toast.error("Adjustments updation failed.");
//     } else {
//       yield put({
//         type: `${value.initActionFail}`,
//       });
//       yield toast.error("Adjustments updation failed!");
//     }
//   }
// }

function* fetchSlabRateReport() {
  const societyId = JSON.parse(localStorage.getItem("FmsUser")).society_id;
  const data = {
    societyId: societyId,
  };
  try {
    // let params = {
    //   api: `${appConfig.urlPrefixIp}/slabquotaadjustmentsservice/society/getslabrate`,
    //   method: "POST",
    //   sucessAction: actionTypes.FETCH_SETTINGS_MWRC_SLAB_RATE_SUCCESS_ACTION,
    //   failAction: actionTypes.FETCH_SETTINGS_MWRC_SLAB_RATE_FAIL_ACTION,
    //   body: JSON.stringify(data),
    // };
    // const Res = yield call(api.commonGetFunction, params);
    // return Res;
    const resJSON = yield call(fmApi.fetchSlabRateApi, data);
    yield put({
      type: actionTypes.FETCH_SETTINGS_MWRC_SLAB_RATE_SUCCESS_ACTION,
      payload: resJSON,
    });
  } catch (err) {
    if (err.ok === false) {
      yield put({
        type: actionTypes.FETCH_SETTINGS_MWRC_SLAB_RATE_FAIL_ACTION,
        error: err,
      });
    } else {
    }
  }
}

function* fetchFixedMonthlyCharge() {
  const societyId = JSON.parse(localStorage.getItem("FmsUser")).society_id;
  const data = {
    societyId: societyId,
  };
  try {
    // let params = {
    //   api: `${appConfig.urlPrefixIp}/slabquotaadjustmentsservice/society/getfixedcharge`,
    //   method: "POST",
    //   sucessAction:
    //     actionTypes.FETCH_SETTINGS_MWRC_FIXED_MONTHLY_CHARGE_SUCCESS_ACTION,
    //   failAction:
    //     actionTypes.FETCH_SETTINGS_MWRC_FIXED_MONTHLY_CHARGE_FAIL_ACTION,
    //   body: JSON.stringify(data),
    // };
    // const Res = yield call(api.commonGetFunction, params);
    // return Res;
    const resJSON = yield call(fmApi.FetchFixedChargeApi, data);
    yield put({
      type: actionTypes.FETCH_SETTINGS_MWRC_FIXED_MONTHLY_CHARGE_SUCCESS_ACTION,
      payload: resJSON,
    });
  } catch (err) {
    if (err.ok === false) {
      yield put({
        type: actionTypes.FETCH_SETTINGS_MWRC_FIXED_MONTHLY_CHARGE_FAIL_ACTION,
        error: err,
      });
    } else {
    }
  }
}

function* editFixedMonthlyCharge(value) {
  const societyId = JSON.parse(localStorage.getItem("FmsUser")).society_id;
  const data = {
    societyId: societyId,
    charge: value?.value,
  };

  try {
    // let params = {
    //   api: `${appConfig.urlPrefixIp}/slabquotaadjustmentsservice/society/updatefixedcharge`,
    //   method: "POST",
    //   sucessAction:
    //     actionTypes.UPDATE_SETTINGS_MWRC_FIXED_MONTHLY_CHARGE_SUCCESS_ACTION,
    //   toastMsg: "Fixed monthly charge updated successfully",
    //   initAction:
    //     actionTypes.FETCH_SETTINGS_MWRC_FIXED_MONTHLY_CHARGE_INIT_ACTION,
    //   failAction:
    //     actionTypes.UPDATE_SETTINGS_MWRC_FIXED_MONTHLY_CHARGE_FAIL_ACTION,
    //   body: JSON.stringify(data),
    // };
    // const Res = yield call(commonPostFunction, params);
    // return Res;

    const resJSON = yield call(fmApi.PatchFixedMonthlyChargeApi, data);

    yield put({
      type: actionTypes.UPDATE_SETTINGS_MWRC_FIXED_MONTHLY_CHARGE_SUCCESS_ACTION,
      payload: resJSON,
    });
    yield put({
      type: actionTypes.FETCH_SETTINGS_MWRC_FIXED_MONTHLY_CHARGE_INIT_ACTION,
      payload: resJSON,
    });
    yield toast.success("Fixed monthly charge updated successfully", {
      autoClose: 3000,
    });
    return resJSON;
  } catch (err) {
    if (err.ok === false) {
      yield put({
        type: actionTypes.UPDATE_SETTINGS_MWRC_FIXED_MONTHLY_CHARGE_FAIL_ACTION,
        error: err,
      });
      if (err.status === 400) {
        yield toast.error(`${endpoints.status400}`, {
          autoClose: 3000,
        });
      } else if (err.status === 500) {
        yield toast.error(`${endpoints.status500}`, {
          autoClose: 3000,
        });
      } else {
      }
    }
  }
}

function* fetchAdjustments() {
  const societyId = JSON.parse(localStorage.getItem("FmsUser")).society_id;
  const data = {
    societyId: societyId,
  };
  try {
    // let params = {
    //   api: `${appConfig.urlPrefixIp}/slabquotaadjustmentsservice/society/getadjustments`,
    //   method: "POST",
    //   sucessAction: actionTypes.FETCH_SETTINGS_MWRC_ADJUSTMENTS_SUCCESS_ACTION,
    //   failAction: actionTypes.FETCH_SETTINGS_MWRC_ADJUSTMENTS_FAIL_ACTION,
    //   body: JSON.stringify(data),
    // };
    // const Res = yield call(api.commonGetFunction, params);
    // return Res;
    const resJSON = yield call(fmApi.FetchAdjustmentApi, data);
    yield put({
      type: actionTypes.FETCH_SETTINGS_MWRC_ADJUSTMENTS_SUCCESS_ACTION,
      payload: resJSON,
    });
  } catch (err) {
    if (err.ok === false) {
      yield put({
        type: actionTypes.FETCH_SETTINGS_MWRC_ADJUSTMENTS_FAIL_ACTION,
        error: err,
      });
    } else {
    }
  }
}

function* AddAjustment(value) {
  const fmsUser = JSON.parse(localStorage.getItem("FmsUser"));
  const data = {
    socId: fmsUser.society_id,
    payments: value?.value?.map((item) => ({
      adjustment: item?.amount,
      aptNumber: item?.aptNo,
    })),
  };
  try {
    const responses = yield call(fmApi.PostUploadPaymentApi, data);
    const allSuccess = responses?.every((item) => item.status == "Success");
    if (allSuccess) {
      yield put({
        type: actionTypes.ADD_SETTINGS_MWRC_ADJUSTMENTS_SUCCESS_ACTION,
        payload: { resJSON: responses },
      });

      yield toast.success("Adjustments updated successfully", {
        autoClose: 3000,
      });
    } else {
      yield put({
        type: actionType.FETCH_COLLECTIONDATA_INIT_ACTION,
      });
      toast.error("Failed to update adjustment");
    }
    return responses;
  } catch (err) {
    if (err.ok === false) {
      yield put({
        type: actionTypes.ADD_SETTINGS_MWRC_ADJUSTMENTS_FAIL_ACTION,
        error: err,
      });
      yield put({
        type: actionType.FETCH_COLLECTIONDATA_INIT_ACTION,
      });
      yield toast.success("Adjustments updation failed.", {
        autoClose: 3000,
      });
    } else {
      yield put({
        type: actionType.FETCH_COLLECTIONDATA_INIT_ACTION,
      });
      yield toast.error("Adjustments updation failed!");
    }
  }
  //*****************************old code */
  // const societyId = JSON.parse(localStorage.getItem("FmsUser")).society_id;
  // const data = {
  //   societyId: societyId,
  //   adjustments: value.value,
  // };

  // try {
  //   // let params = {
  //   //   api: `${appConfig.urlPrefixIp}/slabquotaadjustmentsservice/society/addadjustments`,
  //   //   method: "POST",
  //   //   sucessAction: actionTypes.ADD_SETTINGS_MWRC_ADJUSTMENTS_SUCCESS_ACTION,
  //   //   toastMsg: "Adjustments updated successfully",
  //   //   initAction: actionTypes.FETCH_SETTINGS_MWRC_ADJUSTMENTS_INIT_ACTION,
  //   //   failAction: actionTypes.ADD_SETTINGS_MWRC_ADJUSTMENTS_FAIL_ACTION,
  //   //   initActionFail: actionTypes.FETCH_SETTINGS_MWRC_ADJUSTMENTS_INIT_ACTION,

  //   //   body: JSON.stringify(data),
  //   // };
  //   // const Res = yield call(commonAdjustFunction, params);
  //   // return Res;
  //   const resJSON = yield call(fmApi.PostAdjustmentApi, data);

  //   yield put({
  //     type: actionTypes.ADD_SETTINGS_MWRC_ADJUSTMENTS_SUCCESS_ACTION,
  //     payload: resJSON,
  //   });
  //   yield put({
  //     type: actionTypes.FETCH_SETTINGS_MWRC_ADJUSTMENTS_INIT_ACTION,
  //   });
  //   yield toast.success("Adjustments updated successfully", {
  //     autoClose: 3000,
  //   });
  //   return resJSON;
  // } catch (err) {
  //   if (err.ok === false) {
  //     yield put({
  //       type: actionTypes.ADD_SETTINGS_MWRC_ADJUSTMENTS_FAIL_ACTION,
  //       error: err,
  //     });
  //     yield put({
  //       type: actionTypes.FETCH_SETTINGS_MWRC_ADJUSTMENTS_INIT_ACTION,
  //     });
  //     yield toast.success("Adjustments updation failed.", {
  //       autoClose: 3000,
  //     });
  //   } else {
  //     yield put({
  //       type: actionTypes.FETCH_SETTINGS_MWRC_ADJUSTMENTS_INIT_ACTION,
  //     });
  //     yield toast.error("Adjustments updation failed!");
  //   }
  // }
}

function* updateMWReportCSetting(value) {
  const societyId = JSON.parse(localStorage.getItem("FmsUser")).society_id;
  let autogenerate = value.value.isAutoGenerate;
  const data = {
    societyId: societyId,
    generate: value.value.valvestate,
    prevBalance: value.value.data1.isChecked2 || 0,
    autoSend: value.value.data1.selectedOption || 0,
    sendDate: value?.value?.data1?.inputSetDate || 0,
    dueDays: value?.value?.data1?.inputValue2 || 0,
  };
  try {
    // let params = {
    //   api: `${appConfig.urlPrefixIp}/slabquotaadjustmentsservice/society/autogenerate`,
    //   method: "POST",
    //   sucessAction:
    //     actionTypes.ADD_SETTINGS_REPORT_AUTO_GENERATE_SUCCESS_ACTION,
    //   toastMsg: "Monthly water report card updated successfully",
    //   failAction: actionTypes.ADD_SETTINGS_REPORT_AUTO_GENERATE_FAIL_ACTION,
    //   initAction: autogenerate
    //     ? actionTypes.FETCH_SETTINGS_MWRC_BILL_CYCLE_INIT_ACTION
    //     : actionTypes.FETCH_SETTINGS_REPORT_AUTO_GENERATE_INIT_ACTION,
    //   body: JSON.stringify(data),
    // };
    // const Res = yield call(commonPostFunction, params);
    // return Res;
    const resJSON = yield call(fmApi.PatchWaterReportCard, data);

    yield put({
      type: actionTypes.ADD_SETTINGS_REPORT_AUTO_GENERATE_SUCCESS_ACTION,
      payload: resJSON,
    });
    yield put({
      type: autogenerate
        ? actionTypes.FETCH_SETTINGS_MWRC_BILL_CYCLE_INIT_ACTION
        : actionTypes.FETCH_SETTINGS_REPORT_AUTO_GENERATE_INIT_ACTION,
    });
    yield toast.success("Monthly water report card updated successfully", {
      autoClose: 3000,
    });
    return resJSON;
  } catch (err) {
    if (err.ok === false) {
      yield put({
        type: actionTypes.ADD_SETTINGS_REPORT_AUTO_GENERATE_FAIL_ACTION,
        error: err,
      });
      if (err.status === 400) {
        yield toast.error(`${endpoints.status400}`, {
          autoClose: 3000,
        });
      } else if (err.status === 500) {
        yield toast.error(`${endpoints.status500}`, {
          autoClose: 3000,
        });
      } else {
      }
    }
  }
}

function* aptTypeQuotaNotSet() {
  const societyId = JSON.parse(localStorage.getItem("FmsUser")).society_id;
  const data = {
    societyId: societyId,
  };
  try {
    // let params = {
    //   api: `${appConfig.urlPrefixIp}/apartmentinfoservice/society/quotanotsetapts`,
    //   method: "POST",
    //   sucessAction: actionTypes.FETCH_SETTINGS_QUOTANOTSET_TABLE_SUCCESS_ACTION,
    //   failAction: actionTypes.FETCH_SETTINGS_QUOTANOTSET_TABLE_FAIL_ACTION,
    //   body: JSON.stringify(data),
    // };
    // const Res = yield call(api.commonGetFunction, params);
    // return Res;
    const resJSON = yield call(fmApi.FetchQuotaNotSetAptApi, data);
    yield put({
      type: actionTypes.FETCH_SETTINGS_QUOTANOTSET_TABLE_SUCCESS_ACTION,
      payload: resJSON,
    });
  } catch (err) {
    if (err.ok === false) {
      yield put({
        type: actionTypes.FETCH_SETTINGS_QUOTANOTSET_TABLE_FAIL_ACTION,
        error: err,
      });
    } else {
    }
  }
}

function* fetchSetQuota(values) {
  const societyId = JSON.parse(localStorage.getItem("FmsUser")).society_id;
  const UserName = JSON.parse(localStorage.getItem("FmsUser")).username;
  const data = {
    societyId: societyId,
    username: UserName,
    aptList: values.values.selectedRows,
    quota: values.values.values.quota,
  };
  try {
    // let params = {
    //   api: `${appConfig.urlPrefixIp}/slabquotaadjustmentsservice/society/setquota`,
    //   method: "POST",
    //   sucessAction: actionTypes.FETCH_SETTINGS_QUOTANOTSET_MODAL_SUCCESS_ACTION,
    //   toastMsg: "Quota has been set successfully",
    //   failAction: actionTypes.FETCH_SETTINGS_QUOTANOTSET_MODAL_FAIL_ACTION,
    //   initAction: actionTypes.FETCH_SETTINGS_QUOTANOTSET_TABLE_INIT_ACTION,
    //   body: JSON.stringify(data),
    // };
    // const Res = yield call(commonPostFunction, params);
    // return Res;
    const resJSON = yield call(fmApi.PostSetQuotaApi, data);

    yield put({
      type: actionTypes.FETCH_SETTINGS_QUOTANOTSET_MODAL_SUCCESS_ACTION,
      payload: resJSON,
    });
    yield put({
      type: actionTypes.FETCH_SETTINGS_QUOTANOTSET_TABLE_INIT_ACTION,
    });
    yield toast.success("Quota has been set successfully", {
      autoClose: 3000,
    });
    return resJSON;
  } catch (err) {
    if (err.ok === false) {
      yield put({
        type: actionTypes.FETCH_SETTINGS_QUOTANOTSET_MODAL_FAIL_ACTION,
        error: err,
      });
      if (err.status === 400) {
        yield toast.error(`${endpoints.status400}`, {
          autoClose: 3000,
        });
      } else if (err.status === 500) {
        yield toast.error(`${endpoints.status500}`, {
          autoClose: 3000,
        });
      } else {
      }
    }
  }
}
function* UpdateQuota(values) {
  const societyId = JSON.parse(localStorage.getItem("FmsUser")).society_id;
  const UserName = JSON.parse(localStorage.getItem("FmsUser")).username;
  const data = {
    societyId: societyId,
    username: UserName,
    aptList: values.values.checkedAptIds,
    quota: values.values.values.quota,
    isDefault: values.values.quotaValue,
  };
  try {
    // let params = {
    //   api: `${appConfig.urlPrefixIp}/slabquotaadjustmentsservice/society/updatequota`,
    //   method: "POST",
    //   sucessAction:
    //     actionTypes.ADD_SETTINGS_DAILY_QUOTA_UPDATE_QUOTA_SUCCESS_ACTION,
    //   toastMsg: "Quota updated successfully",
    //   failAction: actionTypes.ADD_SETTINGS_DAILY_QUOTA_UPDATE_QUOTA_FAIL_ACTION,
    //   initAction: actionTypes.FETCH_SETTINGS_DAILY_QUOTA_GET_QUOTA_INIT_ACTION,
    //   body: JSON.stringify(data),
    // };
    // const Res = yield call(commonPostFunction, params);
    // return Res;
    const resJSON = yield call(fmApi.PatchUpdateQuotaApi, data);

    yield put({
      type: actionTypes.ADD_SETTINGS_DAILY_QUOTA_UPDATE_QUOTA_SUCCESS_ACTION,
      payload: resJSON,
    });
    yield put({
      type: actionTypes.FETCH_SETTINGS_DAILY_QUOTA_GET_QUOTA_INIT_ACTION,
    });
    yield toast.success("Quota updated successfully", {
      autoClose: 3000,
    });
    return resJSON;
  } catch (err) {
    if (err.ok === false) {
      yield put({
        type: actionTypes.ADD_SETTINGS_DAILY_QUOTA_UPDATE_QUOTA_FAIL_ACTION,
        error: err,
      });
      if (err.status === 400) {
        yield toast.error(`${endpoints.status400}`, {
          autoClose: 3000,
        });
      } else if (err.status === 500) {
        yield toast.error(`${endpoints.status500}`, {
          autoClose: 3000,
        });
      } else {
      }
    }
  }
}

function* resetQuotaNotSet() {
  const societyId = JSON.parse(localStorage.getItem("FmsUser")).society_id;
  const UserName = JSON.parse(localStorage.getItem("FmsUser")).username;
  const data = {
    societyId: societyId,
    username: UserName,
  };
  try {
    // let params = {
    //   api: `${appConfig.urlPrefixIp}/slabquotaadjustmentsservice/society/resetquota`,
    //   method: "POST",
    //   sucessAction: actionTypes.FETCH_SETTINGS_QUOTANOTSET_RESET_SUCCESS_ACTION,
    //   toastMsg: "Quota reset successfully",
    //   failAction: actionTypes.FETCH_SETTINGS_QUOTANOTSET_RESET_FAIL_ACTION,
    //   initAction: actionTypes.FETCH_SETTINGS_DAILY_QUOTA_GET_QUOTA_INIT_ACTION,
    //   body: JSON.stringify(data),
    // };
    // const Res = yield call(commonPostFunction, params);
    // return Res;
    const resJSON = yield call(fmApi.PostResetQuotaApi, data);

    yield put({
      type: actionTypes.FETCH_SETTINGS_QUOTANOTSET_RESET_SUCCESS_ACTION,
      payload: resJSON,
    });
    yield put({
      type: actionTypes.FETCH_SETTINGS_DAILY_QUOTA_GET_QUOTA_INIT_ACTION,
    });
    yield toast.success("Quota reset successfully", {
      autoClose: 3000,
    });
    return resJSON;
  } catch (err) {
    if (err.ok === false) {
      yield put({
        type: actionTypes.FETCH_SETTINGS_QUOTANOTSET_RESET_FAIL_ACTION,
        error: err,
      });
      if (err.status === 400) {
        yield toast.error(`${endpoints.status400}`, {
          autoClose: 3000,
        });
      } else if (err.status === 500) {
        yield toast.error(`${endpoints.status500}`, {
          autoClose: 3000,
        });
      } else {
      }
    }
  }
}

function* fetchSettingApartment() {
  const societyId = JSON.parse(localStorage.getItem("FmsUser")).society_id;
  const data = {
    societyId: societyId,
  };
  try {
    // let params = {
    //   api: `${appConfig.urlPrefixIp}/apartmentinfoservice/society/getapartmenttype`,
    //   method: "POST",
    //   sucessAction: actionTypes.FETCH_SETTINGS_APARTMENT_SUCCESS_ACTION,
    //   failAction: actionTypes.FETCH_SETTINGS_APARTMENT_FAIL_ACTION,
    //   body: JSON.stringify(data),
    // };
    // const Res = yield call(api.commonGetFunction, params);
    // return Res;
    const resJSON = yield call(fmApi.FetchApartmentTypeApi, data);
    yield put({
      type: actionTypes.FETCH_SETTINGS_APARTMENT_SUCCESS_ACTION,
      payload: resJSON,
    });
  } catch (err) {
    if (err.ok === false) {
      yield put({
        type: actionTypes.FETCH_SETTINGS_APARTMENT_FAIL_ACTION,
        error: err,
      });
    } else {
    }
  }
}

function* updateApartment(values) {
  const societyId = JSON.parse(localStorage.getItem("FmsUser")).society_id;
  const UserName = JSON.parse(localStorage.getItem("FmsUser")).username;
  const capitalizeWord = (data) => {
    if (data) {
      return typeof data === "string"
        ? data.charAt(0).toUpperCase() + data.slice(1)
        : "";
    }
    return data;
  };
  let data = {
    societyId: societyId,
    username: UserName,
    aptNumList: values?.values?.apartmentLis,
    bhk: values?.values?.values?.BhkType,
    property: values.values.values.PropertyType,
    tower: capitalizeWord(values.values.values.Tower),
    floor: values.values.values.floor,
    sqft: parseInt(values.values.values.ApartmentSize),
    noa: parseInt(values.values.values.NoofAdults),
    noc: parseInt(values.values.values.NoofChildren),
  };
  try {
    // let params = {
    //   api: `${appConfig.urlPrefixIp}/apartmentinfoservice/society/setapttype`,
    //   method: "POST",
    //   sucessAction: actionTypes.ADD_SETTINGS_APARTMENT_SUCCESS_ACTION,
    //   toastMsg: "Apartment updated successfully",
    //   failAction: actionTypes.ADD_SETTINGS_APARTMENT_FAIL_ACTION,
    //   initAction: actionTypes.FETCH_SETTINGS_APARTMENT_INIT_ACTION,
    //   body: JSON.stringify(data),
    // };
    // const Res = yield call(commonPostFunction, params);
    // return Res;
    const resJSON = yield call(fmApi.PatchUpdateApartmentApi, data);

    yield put({
      type: actionTypes.ADD_SETTINGS_APARTMENT_SUCCESS_ACTION,
      payload: resJSON,
    });
    yield put({
      type: actionTypes.FETCH_SETTINGS_APARTMENT_INIT_ACTION,
    });
    yield toast.success("Apartment updated successfully", {
      autoClose: 3000,
    });
    return resJSON;
  } catch (err) {
    if (err.ok === false) {
      yield put({
        type: actionTypes.ADD_SETTINGS_APARTMENT_FAIL_ACTION,
        error: err,
      });
      if (err.status === 400) {
        yield toast.error(`${endpoints.status400}`, {
          autoClose: 3000,
        });
      } else if (err.status === 500) {
        yield toast.error(`${endpoints.status500}`, {
          autoClose: 3000,
        });
      } else {
      }
    }
  }
}

function* fetchSocietyTemplate() {
  const societyId = JSON.parse(localStorage.getItem("FmsUser")).society_id;
  const data = {
    societyId: societyId,
  };
  try {
    // let params = {
    //   api: `${appConfig.urlPrefixIp}/identityservice/society/gettemplate`,
    //   method: "POST",
    //   sucessAction: actionTypes.FETCH_SETTINGS_SOCIETY_TEMPLATE_SUCCESS_ACTION,
    //   failAction: actionTypes.FETCH_SETTINGS_SOCIETY_TEMPLATE_FAIL_ACTION,
    //   body: JSON.stringify(data),
    // };
    // const Res = yield call(api.commonGetFunction, params);
    // return Res;
    const resJSON = yield call(fmApi.fetchGetTemplateApi, data);
    yield put({
      type: actionTypes.FETCH_SETTINGS_SOCIETY_TEMPLATE_SUCCESS_ACTION,
      payload: resJSON,
    });
  } catch (err) {
    if (err.ok === false) {
      yield put({
        type: actionTypes.FETCH_SETTINGS_SOCIETY_TEMPLATE_FAIL_ACTION,
        error: err,
      });
    } else {
    }
  }
}

function* updateSocietyAdmin(value) {
  const societyId = JSON.parse(localStorage.getItem("FmsUser")).society_id;
  const regEmail = JSON.parse(localStorage.getItem("FmsUser")).email;
  const contact = JSON.parse(localStorage.getItem("fmsProfDetail")).phone;
  const name = JSON.parse(localStorage.getItem("FmsUser")).society_name;
  let data = {
    societyId: societyId,
    primaryContact: name,
    primaryPhone: contact,
    email: regEmail,
    bill_roundoff: value.value.selectedMonthlyBilling,
    send_alert: 1,
    daily_quota_enable: value.value.showDailyQuataVlave,
    daily_quota_option: value.value.settDailyQuataValve,
    online_bill_payment: value.value.selectedPaymentOption,
  };
  try {
    // let params = {
    //   api: `${appConfig.urlPrefixIp}/identityservice/society/updateadmin`,
    //   method: "POST",
    //   sucessAction: actionTypes.ADD_SETTINGS_SOCIETY_ADMIN_SUCCESS_ACTION,
    //   toastMsg: "Society details updated successfully",
    //   initAction: actionTypes.FETCH_SETTINGS_SOCIETY_PROFILE_INIT_ACTION,
    //   failAction: actionTypes.ADD_SETTINGS_SOCIETY_ADMIN_FAIL_ACTION,
    //   body: JSON.stringify(data),
    // };
    // const Res = yield call(commonPostFunction, params);
    // if (Res) {
    //   yield call(updateTemplate, value.value.selectedOption);
    // }
    // return Res;
    const resJSON = yield call(fmApi.PatchSocietyAdminApi, data);

    yield put({
      type: actionTypes.ADD_SETTINGS_SOCIETY_ADMIN_SUCCESS_ACTION,
      payload: resJSON,
    });
    yield put({
      type: actionTypes.FETCH_SETTINGS_SOCIETY_PROFILE_INIT_ACTION,
    });
    yield toast.success("Society details updated successfully", {
      autoClose: 3000,
    });
    yield call(updateTemplate, value.value.selectedOption);
    return resJSON;
  } catch (err) {
    if (err.ok === false) {
      yield put({
        type: actionTypes.ADD_SETTINGS_SOCIETY_ADMIN_FAIL_ACTION,
        error: err,
      });
      if (err.status === 400) {
        yield toast.error(`${endpoints.status400}`, {
          autoClose: 3000,
        });
      } else if (err.status === 500) {
        yield toast.error(`${endpoints.status500}`, {
          autoClose: 3000,
        });
      } else {
      }
    }
  }
}

function* updateTemplate(value) {
  const societyId = JSON.parse(localStorage.getItem("FmsUser")).society_id;
  const data = {
    societyId: societyId,
    templateid: value,
  };
  try {
    // let params = {
    //   api: `${appConfig.urlPrefixIp}/identityservice/society/settemplate`,
    //   method: "POST",
    //   initAction: actionTypes.FETCH_SETTINGS_SOCIETY_TEMPLATE_INIT_ACTION,
    //   sucessAction: null,
    //   failAction: null,
    //   body: JSON.stringify(data),
    // };
    // const Res = yield call(commonPostFunction, params);
    // return Res;
    const resJSON = yield call(fmApi.PatchUpdateTemplateApi, data);

    yield put({
      type: actionTypes.FETCH_SETTINGS_SOCIETY_TEMPLATE_INIT_ACTION,
    });
    return resJSON;
  } catch (err) {
    if (err.ok === false) {
      if (err.status === 400) {
        yield toast.error(`${endpoints.status400}`, {
          autoClose: 3000,
        });
      } else if (err.status === 500) {
        yield toast.error(`${endpoints.status500}`, {
          autoClose: 3000,
        });
      } else {
      }
    }
  }
}

function* fetchBillCycleDetail() {
  const societyId = JSON.parse(localStorage.getItem("FmsUser")).society_id;
  const data = {
    societyId: societyId,
  };
  try {
    // let params = {
    //   api: `${appConfig.urlPrefixIp}/societydataservice/society/getbillcycledetail`,
    //   method: "POST",
    //   sucessAction: actionTypes.FETCH_SETTINGS_MWRC_BILL_CYCLE_SUCCESS_ACTION,
    //   failAction: actionTypes.FETCH_SETTINGS_MWRC_BILL_CYCLE_FAIL_ACTION,
    //   body: JSON.stringify(data),
    // };
    // const Res = yield call(api.commonGetFunction, params);
    // return Res;
    const resJSON = yield call(fmApi.fetchBillCycleDetailsApi, data);
    yield put({
      type: actionTypes.FETCH_SETTINGS_MWRC_BILL_CYCLE_SUCCESS_ACTION,
      payload: resJSON,
    });
  } catch (err) {
    if (err.ok === false) {
      yield put({
        type: actionTypes.FETCH_SETTINGS_MWRC_BILL_CYCLE_FAIL_ACTION,
        error: err,
      });
    } else {
    }
  }
}

function* editSocietyContactDetail(value) {
  const societyId = JSON.parse(localStorage.getItem("FmsUser")).society_id;
  const UserName = JSON.parse(localStorage.getItem("FmsUser")).username;
  const data = {
    societyId: societyId,
    primaryContact: value.value.primaryContactName,
    primaryPhone: value.value.primaryContactNumber,
    emailId: value.value.primaryEmail,
    username: UserName,
    sendSms: value.value.enableSMS,
    sendmail: value.value.enableEmail,
    technicians: value.value.techniciansData,
  };
  try {
    // let params = {
    //   api: `${appConfig.urlPrefixIp}/societydataservice/society/updatesoccontact`,
    //   method: "POST",
    //   sucessAction: actionTypes.FETCH_SOCIETY_CONTACT_DETAILS_SUCCESS_ACTION,
    //   toastMsg: " Society contacts updated successfully",
    //   initAction: actionTypes.FETCH_SETTINGS_REPORT_SOCIETY_CONTACT_INIT_ACTION,
    //   failAction: actionTypes.FETCH_SOCIETY_CONTACT_DETAILS_FAIL_ACTION,
    //   body: JSON.stringify(data),
    // };
    // const Res = yield call(commonPostFunction, params);
    // return Res;
    const resJSON = yield call(fmApi.PatchSocContactsApi, data);

    yield put({
      type: actionTypes.FETCH_SOCIETY_CONTACT_DETAILS_SUCCESS_ACTION,
      payload: resJSON,
    });
    yield put({
      type: actionTypes.FETCH_SETTINGS_REPORT_SOCIETY_CONTACT_INIT_ACTION,
    });
    yield toast.success("Society contacts updated successfully", {
      autoClose: 3000,
    });
    return resJSON;
  } catch (err) {
    if (err.ok === false) {
      yield put({
        type: actionTypes.FETCH_SOCIETY_CONTACT_DETAILS_FAIL_ACTION,
        error: err,
      });
      if (err.status === 400) {
        yield toast.error(`${endpoints.status400}`, {
          autoClose: 3000,
        });
      } else if (err.status === 500) {
        yield toast.error(`${endpoints.status500}`, {
          autoClose: 3000,
        });
      } else {
      }
    }
  }
}

function* fetchSocietyprofile() {
  const societyId = JSON.parse(localStorage.getItem("FmsUser")).society_id;
  const data = {
    societyId: societyId,
  };
  try {
    // let params = {
    //   api: `${appConfig.urlPrefixIp}/societydataservice/society/profile`,
    //   method: "POST",
    //   sucessAction: actionTypes.FETCH_SETTINGS_SOCIETY_PROFILE_SUCCESS_ACTION,
    //   failAction: actionTypes.FETCH_SETTINGS_SOCIETY_PROFILE_FAIL_ACTION,
    //   body: JSON.stringify(data),
    // };
    // const Res = yield call(api.commonGetFunction, params);
    // return Res;
    const resJSON = yield call(fmApi.fetchProfileApi, data);
    yield put({
      type: actionTypes.FETCH_SETTINGS_SOCIETY_PROFILE_SUCCESS_ACTION,
      payload: resJSON,
    });
  } catch (err) {
    if (err.ok === false) {
      yield put({
        type: actionTypes.FETCH_SETTINGS_SOCIETY_PROFILE_FAIL_ACTION,
        error: err,
      });
    } else {
    }
  }
}

function* fetchaptquota() {
  const societyId = JSON.parse(localStorage.getItem("FmsUser")).society_id;
  const data = {
    societyId: societyId,
  };

  try {
    // let params = {
    //   api: `${appConfig.urlPrefixIp}/slabquotaadjustmentsservice/society/getaptquota`,
    //   method: "POST",
    //   sucessAction:
    //     actionTypes.FETCH_SETTINGS_DAILY_QUOTA_GET_QUOTA_SUCCESS_ACTION,
    //   failAction: actionTypes.FETCH_SETTINGS_DAILY_QUOTA_GET_QUOTA_FAIL_ACTION,
    //   body: JSON.stringify(data),
    // };
    // const Res = yield call(api.commonGetFunction, params);
    // return Res;
    const resJSON = yield call(fmApi.FetchApartmentQuotaApi, data);
    yield put({
      type: actionTypes.FETCH_SETTINGS_DAILY_QUOTA_GET_QUOTA_SUCCESS_ACTION,
      payload: resJSON,
    });
  } catch (err) {
    if (err.ok === false) {
      yield put({
        type: actionTypes.FETCH_SETTINGS_DAILY_QUOTA_GET_QUOTA_FAIL_ACTION,
        error: err,
      });
    } else {
    }
  }
}

function* fetchautogeneratestatus() {
  const societyId = JSON.parse(localStorage.getItem("FmsUser")).society_id;
  const data = {
    societyId: societyId,
  };
  try {
    // let params = {
    //   api: `${appConfig.urlPrefixIp}/billingservice/society/autogeneratestatus`,
    //   method: "POST",
    //   sucessAction:
    //     actionTypes.FETCH_SETTINGS_REPORT_AUTO_GENERATE_SUCCESS_ACTION,
    //   failAction: actionTypes.FETCH_SETTINGS_REPORT_AUTO_GENERATE_FAIL_ACTION,
    //   body: JSON.stringify(data),
    // };
    // const Res = yield call(api.commonGetFunction, params);
    // return Res;
    const resJSON = yield call(fmApi.fetchAutoGenerateStatusApi, data);
    yield put({
      type: actionTypes.FETCH_SETTINGS_REPORT_AUTO_GENERATE_SUCCESS_ACTION,
      payload: resJSON,
    });
  } catch (err) {
    if (err.ok === false) {
      yield put({
        type: actionTypes.FETCH_SETTINGS_REPORT_AUTO_GENERATE_FAIL_ACTION,
        error: err,
      });
    } else {
    }
  }
}

function* updateSlabRate(value) {
  const societyId = JSON.parse(localStorage.getItem("FmsUser")).society_id;
  const data = {
    societyId: societyId,
    slabRates: value.value,
  };

  try {
    // let params = {
    //   api: `${appConfig.urlPrefixIp}/slabquotaadjustmentsservice/society/updateslabrate`,
    //   method: "POST",
    //   sucessAction: actionTypes.UPDATE_SETTINGS_MWRC_SLAB_RATE_SUCCESS_ACTION,
    //   toastMsg: "Slab rates updated successfully.",
    //   initAction: actionTypes.FETCH_SETTINGS_MWRC_SLAB_RATE_INIT_ACTION,
    //   failAction: actionTypes.UPDATE_SETTINGS_MWRC_SLAB_RATE_FAIL_ACTION,
    //   body: JSON.stringify(data),
    // };
    // const Res = yield call(commonPostFunction, params);
    // return Res;
    const resJSON = yield call(fmApi.PatchSlabRateApi, data);

    yield put({
      type: actionTypes.UPDATE_SETTINGS_MWRC_SLAB_RATE_SUCCESS_ACTION,
      payload: resJSON,
    });
    yield put({
      type: actionTypes.FETCH_SETTINGS_MWRC_SLAB_RATE_INIT_ACTION,
    });
    yield toast.success("Slab rates updated successfully", {
      autoClose: 3000,
    });
    return resJSON;
  } catch (err) {
    if (err.ok === false) {
      yield put({
        type: actionTypes.UPDATE_SETTINGS_MWRC_SLAB_RATE_FAIL_ACTION,
        error: err,
      });
      if (err.status === 400) {
        yield toast.error(`${endpoints.status400}`, {
          autoClose: 3000,
        });
      } else if (err.status === 500) {
        yield toast.error(`${endpoints.status500}`, {
          autoClose: 3000,
        });
      } else {
      }
    }
  }
}

function* fetchSocietyContactDetail() {
  const societyId = JSON.parse(localStorage.getItem("FmsUser")).society_id;
  const UserName = JSON.parse(localStorage.getItem("FmsUser")).username;
  const data = {
    socId: societyId,
    username: UserName,
  };
  try {
    // let params = {
    //   api: `${appConfig.urlPrefixIp}/identityservice/society/contact/retrieve`,
    //   method: "POST",
    //   sucessAction:
    //     actionTypes.FETCH_SETTINGS_REPORT_SOCIETY_CONTACT_SUCCESS_ACTION,
    //   failAction: actionTypes.FETCH_SETTINGS_REPORT_SOCIETY_CONTACT_FAIL_ACTION,
    //   body: JSON.stringify(data),
    // };
    // const Res = yield call(api.commonGetFunction, params);
    // return Res;
    const resJSON = yield call(fmApi.FetchRetrieveApi, data);
    yield put({
      type: actionTypes.FETCH_SETTINGS_REPORT_SOCIETY_CONTACT_SUCCESS_ACTION,
      payload: resJSON,
    });
  } catch (err) {
    if (err.ok === false) {
      yield put({
        type: actionTypes.FETCH_SETTINGS_REPORT_SOCIETY_CONTACT_FAIL_ACTION,
        error: err,
      });
    } else {
    }
  }
}

function* fetchApartment() {
  const fmsUser = JSON.parse(localStorage.getItem("FmsUser"));
  const data = {
    societyId: `${fmsUser.society_id}`,
    filter: "Total",
    type: "All",
  };
  try {
    // let params = {
    //   api: `${appConfig.urlPrefixIp}/apartmentinfoservice/society/apartment`,
    //   method: "POST",
    //   sucessAction:
    //     actionTypes.FETCH_SETTINGS_MWRC_FETCH_APARTMENT_SUCCESS_ACTION,
    //   failAction: actionTypes.FETCH_SETTINGS_MWRC_FETCH_APARTMENT_FAIL_ACTION,
    //   body: JSON.stringify(data),
    // };
    // const Res = yield call(api.commonGetFunction, params);
    // return Res;
    const resJSON = yield call(fmApi.fetchApartmentCountApi, data);
    yield put({
      type: actionTypes.FETCH_SETTINGS_MWRC_FETCH_APARTMENT_SUCCESS_ACTION,
      payload: resJSON,
    });
  } catch (err) {
    if (err.ok === false) {
      yield put({
        type: actionTypes.FETCH_SETTINGS_MWRC_FETCH_APARTMENT_FAIL_ACTION,
        error: err,
      });
    } else {
    }
  }
}

function* fetchMeterRent() {
  const fmsUser = JSON.parse(localStorage.getItem("FmsUser"));
  const data = {
    societyId: `${fmsUser.society_id}`,
  };
  try {
    // let params = {
    //   api: `${appConfig.urlPrefixIp}/apartmentinfoservice/society/cafserial`,
    //   method: "POST",
    //   sucessAction: actionTypes.FETCH_SETTINGS_METER_RENT_SUCCESS_ACTION,
    //   failAction: actionTypes.FETCH_SETTINGS_METER_RENT_FAIL_ACTION,
    //   body: JSON.stringify(data),
    // };
    // const Res = yield call(api.commonGetFunction, params);

    // yield put({
    //   type: actionTypes.FETCH_SETTINGS_CAF_INIT_ACTION,
    //   value: Res.response_data,
    // });

    // return Res;
    const resJSON = yield call(fmApi.FetchCafserialApi, data);
    yield put({
      type: actionTypes.FETCH_SETTINGS_METER_RENT_SUCCESS_ACTION,
      payload: resJSON,
    });
    yield put({
      type: actionTypes.FETCH_SETTINGS_CAF_INIT_ACTION,
      value: resJSON.response_data,
    });
  } catch (err) {
    if (err.ok === false) {
      yield put({
        type: actionTypes.FETCH_SETTINGS_METER_RENT_FAIL_ACTION,
        error: err,
      });
    } else {
    }
  }
}

function* fetchCafDetails(values) {
  const fmsUser = JSON.parse(localStorage.getItem("FmsUser"));
  const cafSerial = values?.value["caf-info"][0]?.cafSerial;
  const data = {
    societyId: `${fmsUser.society_id}`,
    cafSerialId: cafSerial,
  };
  try {
    // let params = {
    //   api: `${appConfig.urlPrefixIp}/apartmentinfoservice/society/cafserialinfo`,
    //   method: "POST",
    //   sucessAction: actionTypes.FETCH_SETTINGS_CAF_SUCCESS_ACTION,
    //   failAction: actionTypes.FETCH_SETTINGS_CAF_FAIL_ACTION,
    //   body: JSON.stringify(data),
    // };
    // const Res = yield call(api.commonGetFunction, params);
    // return Res;
    const resJSON = yield call(fmApi.FetchCafserialInfoApi, data);
    yield put({
      type: actionTypes.FETCH_SETTINGS_CAF_SUCCESS_ACTION,
      payload: resJSON,
    });
  } catch (err) {
    if (err.ok === false) {
      yield put({
        type: actionTypes.FETCH_SETTINGS_CAF_FAIL_ACTION,
        error: err,
      });
    } else {
    }
  }
}

function* fetchCafInfoById(values) {
  const fmsUser = JSON.parse(localStorage.getItem("FmsUser"));
  const cafSerial = values?.value?.cafSerial;
  const data = {
    societyId: `${fmsUser.society_id}`,
    cafSerialId: cafSerial,
  };

  try {
    // let params = {
    //   api: `${appConfig.urlPrefixIp}/apartmentinfoservice/society/cafserialinfo`,
    //   method: "POST",
    //   sucessAction: actionTypes.FETCH_SETTINGS_CAFBYID_SUCCESS_ACTION,
    //   failAction: actionTypes.FETCH_SETTINGS_CAFBYID_FAIL_ACTION,
    //   body: JSON.stringify(data),
    // };
    // const Res = yield call(api.commonGetFunction, params);
    // return Res;
    const resJSON = yield call(fmApi.FetchCafserialInfoApi, data);
    yield put({
      type: actionTypes.FETCH_SETTINGS_CAFBYID_SUCCESS_ACTION,
      payload: resJSON,
    });
  } catch (err) {
    if (err.ok === false) {
      yield put({
        type: actionTypes.FETCH_SETTINGS_CAFBYID_FAIL_ACTION,
        error: err,
      });
    } else {
    }
  }
}

function* fetchWaterBillSettings() {
  const societyName = JSON.parse(localStorage.getItem("FmsUser")).society_name;
  const data = {
    societyName: societyName,
    settingsData: {},
  };
  try {
    const resJSON = yield call(fmApi.WaterBillSettingsApi, data);

    yield put({
      type: actionTypes.FETCH_WATER_BILL_SETTINGS_SUCCESS_ACTION,
      payload: resJSON,
    });
  } catch (err) {
    if (err.ok === false) {
      yield put({
        type: actionTypes.FETCH_WATER_BILL_SETTINGS_FAIL_ACTION,
        error: err,
      });
    } else {
    }
  }
}

function* updateWaterBillSettings(values) {
  const societyName = JSON.parse(localStorage.getItem("FmsUser")).society_name;
  const data = {
    societyName: societyName,
    settingsData: values?.value,
  };

  try {
    const resJSON = yield call(fmApi.WaterBillSettingsApi, data);

    if (resJSON?.status == "Success") {
      yield put({
        type: actionTypes.UPDATE_WATER_BILL_SETTINGS_SUCCESS_ACTION,
        payload: resJSON,
      });
      yield put({
        type: actionTypes.FETCH_WATER_BILL_SETTINGS_INIT_ACTION,
      });
      yield toast.success("Updated successfully", {
        autoClose: 3000,
      });
    }
  } catch (err) {
    if (err.ok === false) {
      yield put({
        type: actionTypes.UPDATE_WATER_BILL_SETTINGS_FAIL_ACTION,
        error: err,
      });
    } else {
    }
  }
}

function* fetchFMUsers() {
  const societyName = JSON.parse(localStorage.getItem("FmsUser")).society_name;

  try {
    const resJSON = yield call(fmApi.fmUserApi, societyName);
    yield put({
      type: actionTypes.FETCH_FM_USERS_SUCCESS_ACTION,
      payload: resJSON.data,
    });
  } catch (err) {
    if (err.ok === false) {
      yield put({
        type: actionTypes.FETCH_FM_USERS_FAIL_ACTION,
        error: err,
      });
    } else {
    }
  }
}

export function* SettingsActionWatcher() {
  yield takeEvery(
    actionTypes.FETCH_SETTINGS_MWRC_SLAB_RATE_INIT_ACTION,
    fetchSlabRateReport
  );
  yield takeEvery(
    actionTypes.FETCH_SETTINGS_MWRC_FIXED_MONTHLY_CHARGE_INIT_ACTION,
    fetchFixedMonthlyCharge
  );
  yield takeEvery(
    actionTypes.UPDATE_SETTINGS_MWRC_FIXED_MONTHLY_CHARGE_INIT_ACTION,
    editFixedMonthlyCharge
  );
  yield takeEvery(
    actionTypes.FETCH_SETTINGS_MWRC_ADJUSTMENTS_INIT_ACTION,
    fetchAdjustments
  );
  yield takeEvery(
    actionTypes.ADD_SETTINGS_MWRC_ADJUSTMENTS_INIT_ACTION,
    AddAjustment
  );
  yield takeEvery(
    actionTypes.ADD_SETTINGS_REPORT_AUTO_GENERATE_INIT_ACTION,
    updateMWReportCSetting
  );
  yield takeEvery(
    actionTypes.FETCH_SETTINGS_QUOTANOTSET_TABLE_INIT_ACTION,
    aptTypeQuotaNotSet
  );
  yield takeEvery(
    actionTypes.FETCH_SETTINGS_QUOTANOTSET_MODAL_INIT_ACTION,
    fetchSetQuota
  );
  yield takeEvery(
    actionTypes.FETCH_SETTINGS_QUOTANOTSET_RESET_INIT_ACTION,
    resetQuotaNotSet
  );
  yield takeEvery(
    actionTypes.FETCH_SETTINGS_APARTMENT_INIT_ACTION,
    fetchSettingApartment
  );
  yield takeEvery(
    actionTypes.ADD_SETTINGS_APARTMENT_INIT_ACTION,
    updateApartment
  );
  yield takeEvery(
    actionTypes.ADD_SETTINGS_DAILY_QUOTA_UPDATE_QUOTA_INIT_ACTION,
    UpdateQuota
  );
  yield takeEvery(
    actionTypes.FETCH_SETTINGS_SOCIETY_TEMPLATE_INIT_ACTION,
    fetchSocietyTemplate
  );
  yield takeEvery(
    actionTypes.ADD_SETTINGS_SOCIETY_ADMIN_INIT_ACTION,
    updateSocietyAdmin
  );
  yield takeEvery(
    actionTypes.FETCH_SETTINGS_MWRC_BILL_CYCLE_INIT_ACTION,
    fetchBillCycleDetail
  );
  yield takeEvery(
    actionTypes.FETCH_SETTINGS_SOCIETY_PROFILE_INIT_ACTION,
    fetchSocietyprofile
  );
  yield takeEvery(
    actionTypes.FETCH_SOCIETY_CONTACT_DETAILS_INIT_ACTION,
    editSocietyContactDetail
  );
  yield takeEvery(
    actionTypes.FETCH_SETTINGS_DAILY_QUOTA_GET_QUOTA_INIT_ACTION,
    fetchaptquota
  );
  yield takeEvery(
    actionTypes.FETCH_SETTINGS_REPORT_AUTO_GENERATE_INIT_ACTION,
    fetchautogeneratestatus
  );
  yield takeEvery(
    actionTypes.UPDATE_SETTINGS_MWRC_SLAB_RATE_INIT_ACTION,
    updateSlabRate
  );
  yield takeEvery(
    actionTypes.FETCH_SETTINGS_REPORT_SOCIETY_CONTACT_INIT_ACTION,
    fetchSocietyContactDetail
  );
  yield takeEvery(
    actionTypes.FETCH_SETTINGS_MWRC_FETCH_APARTMENT_INIT_ACTION,
    fetchApartment
  );
  yield takeEvery(
    actionTypes.FETCH_SETTINGS_METER_RENT_INIT_ACTION,
    fetchMeterRent
  );
  yield takeEvery(actionTypes.FETCH_SETTINGS_CAF_INIT_ACTION, fetchCafDetails);
  yield takeEvery(
    actionTypes.FETCH_SETTINGS_CAFBYID_INIT_ACTION,
    fetchCafInfoById
  );
  yield takeEvery(
    actionTypes.FETCH_WATER_BILL_SETTINGS_INIT_ACTION,
    fetchWaterBillSettings
  );
  yield takeEvery(
    actionTypes.UPDATE_WATER_BILL_SETTINGS_INIT_ACTION,
    updateWaterBillSettings
  );
  yield takeEvery(actionTypes.FETCH_FM_USERS_INIT_ACTION, fetchFMUsers);
}
